/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenData interface.
 */
export function instanceOfFxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenData(value) {
    return true;
}
export function FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenDataFromJSON(json) {
    return FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenDataFromJSONTyped(json, false);
}
export function FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'RedirectUri': json['redirect_uri'] == null ? undefined : json['redirect_uri'],
        'OrderPublicId': json['order_public_id'] == null ? undefined : json['order_public_id'],
        'MerchantRedirectType': json['merchant_redirect_type'] == null ? undefined : json['merchant_redirect_type'],
    };
}
export function FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenDataToJSON(json) {
    return FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenDataToJSONTyped(json, false);
}
export function FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'redirect_uri': value['RedirectUri'],
        'order_public_id': value['OrderPublicId'],
        'merchant_redirect_type': value['MerchantRedirectType'],
    };
}
//# sourceMappingURL=FxIdApplicationSecurityFxIdTempTokenJwtFxIdTempTokenData.js.map